// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1aIR2","icon":"style_icon__2Lgyf","text":"style_text__2kJo0","title":"style_title__zExzX"};